// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2xR7R","loadingEffect":"styles_loadingEffect__3s24R","reveal":"styles_reveal__Urp19"};